// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"af1df007","52":"02a6570c","58":"0fa0941b","83":"d8587f24","236":"2be6a36a","299":"c13b53aa","329":"624c31f4","453":"b0363df4","754":"382cefe7","918":"a7ba7ca2"}[chunkId] + ".chunk.js";
};